import React from 'react';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLinkedin } from '@fortawesome/free-brands-svg-icons';
import smallLogo from '../img/dj-logo-small.svg';
import useHomeLinkClick from '../custom-hooks/useHomeLinkClick.js';
import { NAV_LINKS, CONTACT } from '../siteConfig.js';

function Footer() {
  const currentYear = new Date().getFullYear();
  const handleHomeClick = useHomeLinkClick();

  return (
    <div className="w-full bg-dj-dark py-12 md:py-16 flex justify-center">
      <div className="w-full max-w-[2000px] px-4 md:px-20">
        {/* Footer Content Grid */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 mb-12 md:mb-16">
          {/* Brand Section */}
          <div>
            <img 
              src={smallLogo} 
              alt="DJ Logo" 
              className="w-28 md:w-48 h-16 md:h-24 object-contain mb-4"
            />
            <h2 className="text-2xl font-bold text-white mb-4">Derek Johnston</h2>
            <p className="text-gray-400 text-sm leading-relaxed">
              Design Strategist & UX leader crafting scalable, human-centered digital experiences.
            </p>
          </div>

          {/* Navigation Links */}
          <div>
            <h3 className="text-sm font-semibold uppercase tracking-widest text-primary mb-4">Navigation</h3>
            <nav className="space-y-3">
              {NAV_LINKS.map((link) => (
                <div key={link.label}>
                  {link.isRoute ? (
                    <Link to={link.href} onClick={handleHomeClick} className="text-gray-300 hover:text-primary transition-colors">
                      {link.label}
                    </Link>
                  ) : (
                    <a href={link.href} className="text-gray-300 hover:text-primary transition-colors">
                      {link.label}
                    </a>
                  )}
                </div>
              ))}
            </nav>
          </div>

          {/* Social Links */}
          <div>
            <h3 className="text-sm font-semibold uppercase tracking-widest text-primary mb-4">Connect</h3>
            <div className="flex gap-4">
              <a
                href={CONTACT.linkedin}
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 rounded-lg bg-primary/10 flex items-center justify-center text-primary hover:bg-primary hover:text-dj-dark transition-colors"
                title="LinkedIn"
              >
                <FontAwesomeIcon icon={faLinkedin} />
              </a>
            </div>
          </div>
        </div>

        {/* Divider */}
      <div className="border-t border-secondary pt-8 md:pt-12">
        {/* Footer Bottom */}
        <div className="flex flex-col md:flex-row md:justify-between md:items-center gap-4">
          <p className="text-gray-500 text-sm">
            © {currentYear} Derek Johnston. All rights reserved.
          </p>
          <p className="text-gray-500 text-sm">
            Designed & built with care
          </p>
        </div>
      </div>
      </div>
    </div>
  );
}

export default Footer;